export default "__VITE_ASSET__34Anl6nZ__"